import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EventService } from "../../event-service/event.service";
import { BaseIntegration } from "./base-integration";

@Injectable()
export class JiraIssueService extends BaseIntegration {
  constructor(eventService: EventService, http: HttpClient) {
    super(eventService, http);
  }

  protected serviceName() {
    return "jira";
  }

  protected url(notice: any) {
    return `/api/v3/projects/${notice.projectId}/groups/${notice.groupId}/jira-issues`;
  }

  protected afterCreate(data: any, inst: any) {
    inst.url = data.url;
    return inst;
  }
}
